import { connect } from 'react-redux';
import ReviewFormView from './review_form_view';
import { formValueSelector, getFormValues } from '../../../../../common/form';
import { getCandidate, getPathway } from '../../../../../reducer';

const selector = formValueSelector('selectCandidatesForm');

const mapStateToProps = (state) => {
  const chosenPathwayId = selector(state, 'pathwayType');

  const candidates = selector(state, 'candidates').keySeq().toList();

  const candidateList = candidates.map((candidateId) => {
    const candidate = getCandidate(state, candidateId);
    return [candidate.get('id'), `${candidate.getIn(['user', 'firstName'])} ${candidate.getIn(['user', 'lastName'])}`];
  });

  return {
    pathway: getPathway(state, chosenPathwayId),
    name: selector(state, 'selectCandidatesForm'),
    startsOn: selector(state, 'startDate'),
    description: selector(state, 'description'),
    stepDates: selector(state, 'pathwayStepDates')?.toJS(),
    candidates: candidateList,
    formValues: getFormValues('selectCandidatesForm')(state),
  };
};

const ReviewFormContainer = connect(mapStateToProps)(ReviewFormView);

export default ReviewFormContainer;
